import { ChangeEvent, FC, useEffect, useRef } from 'react'
import classes from './ScanField.module.css'
import { observer } from 'mobx-react-lite'
import { appStore } from '../../../index'

export type ScanFieldProps = {
  onChange: (val: string) => void
}

export const ScanField: FC<ScanFieldProps> = observer(({ onChange }) => {
  const refField = useRef<HTMLTextAreaElement>(null)
  useEffect(() => {
    const interval = window.setInterval(() => {
      refField.current?.focus()
    }, 20)
    return () => {
      window.clearInterval(interval)
    }
  }, [])

  const _onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = e.target
    appStore.setScannerField(value)
    onChange(value)
  }

  return (
    <textarea inputMode='none' ref={refField} readOnly={appStore.scannerDisabled} className={classes.field} value={appStore.scannerField} onChange={_onChange}/>
  )
})
